import React, { useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  Modal,
  Progress,
  Radio,
  Select,
  Switch,
  TimePicker,
  Upload,
  message,
} from 'antd';
const { TextArea } = Input;
import moment from 'moment';
import { LuUpload } from 'react-icons/lu';
import { FaLock } from 'react-icons/fa';
import Cookies from 'js-cookie';
import axios from '../../backendService';
import ExistingVideosModal from './ExistingVideosModal';

// Firebase imports
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { app } from '../../config/firbase-config';
import { MdCancel, MdDone } from 'react-icons/md';

const ScheduleVideoModal = ({ isVisible, handleCancel }) => {
  const [form] = Form.useForm();

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');

  const [title, setTitle] = useState('');

  // Key of file uploaded to s3 bucket
  const [fileKey, setFileKey] = useState(null);

  // For file upload to firebase
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [showUploadBar, setShowUploadBar] = useState(false);
  const [currentUploadTask, setCurrentUploadTask] = useState(null);

  // Logic for rendering diff upload sections
  const [showNewUploadSection, setNewShowUploadSection] = useState(false);
  const [showUploadSection, setShowUploadSection] = useState(false);

  // Show publishDate and time
  const [toPublish, setToPublish] = useState(true);

  const [courseList, setCourseList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [chapterList, setChapterList] = useState([]);
  const [topicList, setTopicList] = useState([]);

  const [courseId, setCourseId] = useState('');
  const [subjectId, setSubjectId] = useState('');
  const [chapterId, setChapterId] = useState('');
  const [topicId, setTopicId] = useState('');

  const [loading, setLoading] = useState(false);

  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [videoURL, setVideoURL] = useState(null);

  const closeExistingVideoModal = () => {
    setOpenVideoModal(false);
  };

  const clearUploadedFile = () => {
    form.setFieldValue('videoFile', null);
    if (currentUploadTask) {
      currentUploadTask.cancel();
      setShowUploadBar(false); // Hide the upload bar as the upload is cancelled
    }
    setUploadPercentage(0);
    setFileName('');
    setFile(null);
  };

  const userId = Cookies.get('userId');

  const fetchCourseData = async () => {
    try {
      const response = await axios.get(`/users/${userId}`);
      const resData = await response.data.data.data.courses;
      setCourseList(resData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchUserSubjects = async (userId, courseId) => {
    try {
      const response = await axios.get(`/users/${userId}/${courseId}`);
      const userSubjects = await response.data.commonSubjects;
      if (userSubjects) {
        setSubjectList(userSubjects);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchChapters = async (idOfSubject) => {
    try {
      const response = await axios.get(`/subjects/${idOfSubject}/chapterInfo`);
      const chaptersData = await response.data;
      if (chaptersData) {
        setChapterList(chaptersData);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchTopics = async (idOfChapter) => {
    try {
      const response = await axios.get(`/chapters/${idOfChapter}/topics`);
      const topicData = await response.data;
      if (topicData) {
        setTopicList(topicData);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchCourseData();
  }, []);

  useEffect(() => {
    setSubjectList([]);
    setChapterList([]);
    setTopicList([]);
    form ? form.setFieldValue('subjectName', null) : null;
    form ? form.setFieldValue('chapterName', null) : null;
    form ? form.setFieldValue('topicName', null) : null;
    fetchUserSubjects(userId, courseId);
  }, [courseId]);

  useEffect(() => {
    setChapterList([]);
    setTopicList([]);
    form ? form.setFieldValue('chapterName', null) : null;
    form ? form.setFieldValue('topicName', null) : null;
    if (subjectId) {
      fetchChapters(subjectId);
    }
  }, [subjectId]);

  useEffect(() => {
    setTopicList([]);
    form ? form.setFieldValue('topicName', null) : null;
    if (chapterId) {
      fetchTopics(chapterId);
    }
  }, [chapterId]);

  // useEffect(() => {
  //   console.log(videoURL);
  // }, [videoURL]);

  const handleFileUpload = (file) => {
    const storage = getStorage(app);
    // const fileName = file.name + '_' + new Date();
    const uniqueSuffix = Date.now() + '-' + Math.round(Math.random() * 1e9);
    const newfileName = title.replace(/\s/g, '') + '_' + uniqueSuffix;
    const storageRef = ref(storage, newfileName);
    const uploadTask = uploadBytesResumable(storageRef, file);
    setCurrentUploadTask(uploadTask);
    setShowUploadBar(true);
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setUploadPercentage(progress.toFixed(2));
        console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
          case 'paused':
            console.log('Upload is paused');
            break;
          case 'running':
            console.log('Upload is running');
            break;
        }
      },
      (error) => {
        setShowUploadBar(false);
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case 'storage/unauthorized':
            // User doesn't have permission to access the object
            break;
          case 'storage/canceled':
            // User canceled the upload
            break;

          // ...

          case 'storage/unknown':
            // Unknown error occurred, inspect error.serverResponse
            break;
        }
      },
      () => {
        // Upload completed successfully, now we can get the download URL
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          message.success('Video is ready to upload');
          console.log('File available at', downloadURL);
          setVideoURL(downloadURL);
        });
      },
    );
  };

  // Form submit function
  const handleFormSubmit = async (values) => {
    setLoading(true);

    // const date = values.publishDate ? form.getFieldValue('publishDate').format('YYYY-MM-DD') : '';
    // const startTime = values.startTime ? form.getFieldValue('startTime').format('HH:mm') : '';
    // const endTime = values.endTime ? form.getFieldValue('endTime').format('HH:mm') : '';

    const formData = new FormData();
    formData.append('file', file);
    // formData.append('videoURL', videoURL);
    // formData.append('title', values.videoTitle);
    // formData.append('description', values.videoDesc);
    // formData.append('course', courseId);
    // formData.append('subject', subjectId);
    // formData.append('chapter', chapterId);
    // formData.append('topic', topicId);
    // formData.append('teacher', userId);

    // if (values.publishDate && values.startTime && values.endTime) {
    //   const date = form.getFieldValue('publishDate').format('YYYY-MM-DD');
    //   const startTime = form.getFieldValue('startTime').format('HH:mm');
    //   const endTime = form.getFieldValue('endTime').format('HH:mm');
    //   formData.append('publishDate', date);
    //   formData.append('startTime', startTime);
    //   formData.append('endTime', endTime);
    // }

    formData.forEach((value, key) => {
      console.log(key, value);
    });

    try {
      const res = await axios.post('/videos/fileUpload', formData, {
        onUploadProgress: (p) => {
          const percentageCompleted = Math.round((p.loaded * 100) / p.total);
          setUploadPercentage(percentageCompleted);
          console.log(`${percentageCompleted}% uploaded`);
        },
      });
      setLoading(false);
      console.log(res.data);
      setFileKey(res.data.uploadedToS3.updatedFileName);
      // clearUploadedFile();
      // setShowUploadSection(false);
      // setNewShowUploadSection(false);
      // handleCancel();
      // form.resetFields();
      // message.success('Lecture uploaded, Please refresh page once to see the changes');
    } catch (err) {
      console.error('Error:', err.response ? err.response.data : err.message);
    }
  };

  // Delete uploaded file function
  const handleFileDelete = async () => {
    try {
      const response = await axios.delete(`/videos/delete/${fileKey}`);
      console.log(response.data);
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
    }
  };

  const handleSelectedLiveStream = () => {
    setShowUploadSection(false);
    setNewShowUploadSection(false);
  };

  const handleSelectedNewLecture = () => {
    setShowUploadSection(true);
    setNewShowUploadSection(false);
  };

  const handleSelectedExisitingLecture = () => {
    setShowUploadSection(false);
    setNewShowUploadSection(true);
  };

  return (
    <>
      <Modal
        disabled={loading}
        open={isVisible}
        title="Schedule a video lecture"
        okText="Create"
        style={{ top: 20 }}
        cancelText="Cancel"
        onCancel={handleCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              handleFormSubmit(values);
              // setShowUploadSection(false);
              // setNewShowUploadSection(false);
              // clearUploadedFile();
              // console.log(values);
              // form.resetFields();
            })
            .catch((info) => {
              console.log('Validate Failed:', info);
            });
        }}
      >
        <Form
          form={form}
          disabled={loading}
          layout="horizontal"
          name="form_in_modal"
          labelCol={{ span: 8 }} // Adjust the span value as per your requirement
        >
          <Form.Item
            style={{ margin: '0 0 10px 0' }}
            name="videoTitle"
            label="Topic title"
            rules={[{ required: false, message: 'Please input the title of collection!' }]}
          >
            <Input
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter video title"
              size="small"
              style={{ width: '100%' }}
            />
          </Form.Item>
          <Form.Item
            style={{ margin: '0 0 10px 0' }}
            name="videoDesc"
            label="Topic description"
            rules={[{ required: false, message: 'Please input the title of collection!' }]}
          >
            <TextArea rows={4} placeholder="Enter video description" size="small" style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            style={{ margin: '10px 0' }}
            name="courseName"
            label="Select course"
            rules={[{ required: false, message: 'Please select a course!' }]}
          >
            <Select placeholder="Select course" style={{ width: '100%' }} size="small" onChange={(e) => setCourseId(e)}>
              {courseList.map((course) => (
                <Select.Option key={course.courseName} value={course._id}>
                  {course.courseName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            style={{ margin: '10px 0' }}
            name="subjectName"
            label="Select Subject"
            rules={[{ required: false, message: 'Please select a subject!' }]}
          >
            <Select
              disabled={subjectList.length === 0}
              placeholder="Select subject"
              style={{ width: '100%' }}
              size="small"
              onChange={(e) => setSubjectId(e)}
            >
              {subjectList.map((subject) => (
                <Select.Option key={subject.subjectName} value={subject._id}>
                  {subject.subjectName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            placeholder="Select Chapter"
            style={{ margin: '10px 0' }}
            name="chapterName"
            label="Select Chapter"
            rules={[{ required: false, message: 'Please select a chapter!' }]}
          >
            <Select
              disabled={chapterList.length === 0}
              onChange={(e) => setChapterId(e)}
              placeholder="Select chapter"
              style={{ width: '100%' }}
              size="small"
            >
              {chapterList.map((chapter) => (
                <Select.Option key={chapter.chapterName} value={chapter._id}>
                  {chapter.chapterName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            style={{ margin: '10px 0' }}
            name="topicName"
            label="Select Topic"
            rules={[{ required: false, message: 'Please select a topic!' }]}
          >
            <Select
              onChange={(e) => setTopicId(e)}
              disabled={topicList.length === 0}
              placeholder="Select Topic"
              style={{ width: '100%' }}
              size="small"
            >
              {topicList.map((topic) => (
                <Select.Option key={topic.topicName} value={topic._id}>
                  {topic.topicName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          {/* <Form.Item
            style={{ margin: '10px 0' }}
            name="batches"
            label="Student Batches"
            rules={[{ required: false, message: 'Please select a topic!' }]}
            disabled
          >
            <>
              <Checkbox disabled className="py-1" value="all" checked={false}>
                All
              </Checkbox>
              <Select
                disabled
                mode="multiple"
                allowClear
                style={{
                  width: '100%',
                }}
                placeholder="Add batches"
                className="text-xs"
                options={[
                  { value: 'btch1', label: 'btch1' },
                  { value: 'btch2', label: 'btch2' },
                  { value: 'btch3', label: 'btch3' },
                  { value: 'btch4', label: 'btch4' },
                ]}
              />
            </>
          </Form.Item> */}
          <Form.Item
            style={{ margin: '10px 0' }}
            name="tobePublish"
            label="To be published"
            rules={[{ required: false, message: 'Please select a date!' }]}
          >
            <Switch onClick={() => setToPublish(!toPublish)} />
          </Form.Item>

          {/* Date/ startTime/endTime */}
          <Form.Item
            style={{ margin: '10px 0' }}
            name="publishDate"
            label="Date"
            rules={[{ required: false, message: 'Please select a date!' }]}
          >
            <DatePicker
              disabled={toPublish}
              size="small"
              disabledDate={(current) => {
                return current && current < moment().startOf('day');
              }}
            />
          </Form.Item>
          <Form.Item
            style={{ margin: '10px 0' }}
            name="startTime"
            label="Start Time"
            rules={[{ required: false, message: 'Please select a start time!' }]}
          >
            <TimePicker disabled={toPublish} size="small" format={'HH:mm'} />
          </Form.Item>
          <Form.Item
            style={{ margin: '10px 0' }}
            name="endTime"
            label="End Time"
            rules={[{ required: false, message: 'Please select a end time!' }]}
          >
            <TimePicker disabled={toPublish} size="small" format={'HH:mm'} />
          </Form.Item>

          {/* Upload section */}
          <Form.Item
            style={{ color: 'bbb' }}
            name="isLive"
            label="Lecture Type"
            rules={[{ required: false, message: 'Please select type of lecture!' }]}
            className="collection-create-form_last-form-item"
          >
            <Radio.Group>
              {/* <Radio onClick={() => handleSelectedLiveStream()} className="py-1" value="live">
                Schedule live lecture
              </Radio> */}
              <Radio onClick={() => handleSelectedNewLecture()} value="newVideo">
                Upload recorded video
              </Radio>
              <Radio onClick={() => handleSelectedExisitingLecture()} value="existingVideo">
                Reschedule existing lecture
              </Radio>
            </Radio.Group>
          </Form.Item>
          {showUploadSection && (
            <>
              <Form.Item
                name="newVideoFile"
                label="Upload new lecture"
                rules={[{ required: showUploadSection ? true : false, message: 'Please select type of lecture!' }]}
                className="collection-create-form_last-form-item"
              >
                <Upload
                  maxCount={1}
                  beforeUpload={(file) => {
                    const isAllowedType = [
                      'video/mp4',
                      'video/mkv',
                      'video/avi',
                      'video/webm',
                      'video/x-matroska',
                    ].includes(file.type);
                    if (!isAllowedType) {
                      message.error('Only mp4, avi, mkv, webm video files are allowed');
                      return Upload.LIST_IGNORE; // Prevents the file from being added to the upload list
                    }
                    return true; // Allows the upload to proceed
                    // console.log(file.type);
                  }}
                  customRequest={(info) => {
                    console.log(info.file.name);
                    // handleFileUpload(info.file);
                    setFile(info.file);
                    setFileName(info.file.name);
                  }}
                  showUploadList={false}
                >
                  <Button className="text-sm text-blue-700 font-semibold gap-2 flex items-center justify-start">
                    <span className="w-max">Upload a new file</span>
                    <span>
                      <LuUpload />
                    </span>
                  </Button>
                </Upload>
              </Form.Item>
            </>
          )}

          {showNewUploadSection && (
            <Form.Item
              name="newVideoFile"
              label="Select existing lecture"
              rules={[{ required: showUploadSection ? true : false, message: 'Please select type of lecture!' }]}
              className="collection-create-form_last-form-item"
            >
              <>
                <div className="flex items-center justify-start gap-4">
                  <Button
                    onClick={() => setOpenVideoModal(true)}
                    className="my-2 text-sm text-blue-700 font-semibold gap-2 flex items-center justify-start cursor-pointer"
                  >
                    <span>Select from personal video pool</span>
                    <span>
                      <LuUpload />
                    </span>
                  </Button>
                  {/* <FaLock color="gray" /> */}
                </div>
                <div className="flex items-center justify-start gap-4">
                  <Button
                    disabled
                    className="text-sm text-blue-700 font-semibold gap-2 flex items-center justify-start cursor-pointer"
                  >
                    <span>Select from media pool</span>
                    <span>
                      <LuUpload />
                    </span>
                  </Button>
                  <FaLock color="gray" />
                </div>
              </>
            </Form.Item>
          )}
          {fileName !== '' && (
            <Form.Item
              style={{ color: 'bbb' }}
              label="Selected Video"
              className="collection-create-form_last-form-item"
            >
              {fileName ? fileName : ''}
              {fileName !== '' && (
                <Button onClick={clearUploadedFile} type="default" size="small" className="bg-red-500 text-white ml-2">
                  Delete
                </Button>
              )}
            </Form.Item>
          )}
          {/* {uploadPercentage > 0 && showUploadBar && (
            <div className="flex items-center justify-start gap-4"> */}
          <Progress percent={uploadPercentage} />
          {/* <Button onClick={clearUploadedFile} size="small" type={uploadPercentage <= 100 ? 'danger' : 'primary'}>
                {uploadPercentage < 100 ? <MdCancel className="w-3 h-3" /> : ''}
              </Button>
            </div>
          )} */}
        </Form>
      </Modal>
      <ExistingVideosModal
        isOpen={openVideoModal}
        videoPlayerClose={closeExistingVideoModal}
        setVideoURL={setVideoURL}
        setFileName={setFileName}
      />
    </>
  );
};

export default ScheduleVideoModal;
